document.documentElement.classList.remove('no-js');
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-add-to-cart]');
  if (!trigger) return;
  const variantId = trigger.dataset.variantId;
  if (!variantId) return;
  trigger.disabled = true;
  const original = trigger.textContent;
  trigger.textContent = 'Adding…';
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
    });
    if (!response.ok) throw new Error('Unable to add item');
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    trigger.textContent = 'Added ✓';
    setTimeout(() => trigger.textContent = original, 1400);
  } catch (error) {
    trigger.textContent = 'Try again';
  } finally {
    setTimeout(() => trigger.disabled = false, 700);
  }
});
document.addEventListener('click', (event) => {
  const menu = event.target.closest('[data-menu-toggle]');
  if (!menu) return;
  const nav = document.querySelector('[data-mobile-nav]');
  const open = nav.toggleAttribute('data-open');
  menu.setAttribute('aria-expanded', String(open));
});
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery?.querySelector('[data-gallery-main]');
    if (main) {
      main.style.opacity = '0.35';
      main.src = thumb.dataset.gallerySrc;
      main.alt = thumb.dataset.galleryAlt || '';
      main.onload = () => { main.style.opacity = '1'; };
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(el => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const count = gallery.querySelector('.product-gallery__count');
      if (count) count.textContent = thumb.dataset.galleryIndex + ' / ' + gallery.querySelectorAll('[data-gallery-thumb]').length;
    }
    return;
  }
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const input = (minus || plus).parentElement.querySelector('input');
    if (minus) input.stepDown(); else input.stepUp();
  }
});
document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-variant-input]');
  if (!input) return;
  const section = input.closest('[data-product-section]');
  const price = section.querySelector('[data-product-price]');
  const compare = section.querySelector('[data-product-compare]');
  const buttonPrice = section.querySelector('[data-button-price]');
  const submit = section.querySelector('[data-product-submit]');
  const label = section.querySelector('[data-submit-label]');
  const available = input.dataset.available === 'true';
  const priced = input.dataset.priced !== 'false';
  if (price) price.textContent = input.dataset.price;
  if (compare) {
    compare.textContent = input.dataset.compare || '';
    compare.hidden = !input.dataset.compare || !priced;
  }
  if (submit) submit.disabled = !available || !priced;
  if (label) label.textContent = !priced ? 'Price coming soon' : (available ? 'Add to cart' : 'Sold out');
  if (buttonPrice) {
    buttonPrice.hidden = !priced || !available;
    buttonPrice.textContent = priced ? input.dataset.price : '';
  }
  history.replaceState({}, '', location.pathname + '?variant=' + input.value);
});
